import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import Popover from 'material-ui/Popover';
import styled from 'styled-components';

const StyledPopoverChildrenWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

class DropDownButton extends Component {
    state = {
        showItems: false,
    };

    openPopover = (event) => {
        event.preventDefault();

        this.setState({
            anchorEl: event.currentTarget,
            showItems: true,
        });
    }

    closePopover = () => {
        this.setState({
            showItems: false,
        });
    }

    render() {
        const { children, title } = this.props;
        const { anchorEl, showItems } = this.state;

        return (
            <div>
                <Button onClick={ this.openPopover } title={ title } />

                <Popover
                    anchorEl={ anchorEl }
                    anchorOrigin={ { horizontal: 'right', vertical: 'bottom' } }
                    onRequestClose={ this.closePopover }
                    open={ showItems }
                    targetOrigin={ { horizontal: 'right', vertical: 'top' } }
                >
                    <StyledPopoverChildrenWrapper>
                        { children }
                    </StyledPopoverChildrenWrapper>
                </Popover>
            </div>
        );
    }
}

DropDownButton.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    title: PropTypes.string.isRequired,
};

export default DropDownButton;


// WEBPACK FOOTER //
// ./src/components/button/DropDownButton.js